import * as types from './types'
import globals from '@/plugins/globals.js'

export default {
  [types.SET_CRITERIA_CHANGED](state, value) {
    state.criteriaChanged = value
  },
  [types.SET_TOOLS](state, data) {
    state.tools = data
    state.tools.forEach(element => {
      element.connected = false
      element.elapsedTime = globals.elapsedTime(element.lastEditedTime, '')
    })
  },
  [types.RESET_TOOLS](state, data) {
    state.shopDevices = []
    data.forEach(element => {
      element.isTool = false
    })
    state.tools.forEach(tool => {
      data.forEach(element => {
        if (parseInt(element.serialNumber) === parseInt(tool.serialNumber)) {
          tool.connected = true
          element.isTool = true
        }
      })
    })
    data.forEach(element => {
      if (!element.isTool) {
        state.shopDevices.push(element)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/mutations.js